import infra from './infra';

export default {
  infra,
};
